// extracted by mini-css-extract-plugin
export default {"wrapper":"hZKh7yw7QDKxi5CQfpdp","title":"cvXVyKF0sbZTPu2GswBN","periodResults":"zaPMPzsPpNl3cb8LOxlB"};